import { render, staticRenderFns } from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=template&id=6474a3e2&scoped=true&"
import script from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=style&index=0&id=6474a3e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474a3e2",
  null
  
)

export default component.exports